import { render, staticRenderFns } from "./modelAttr.vue?vue&type=template&id=8b88b2ec&"
import script from "./modelAttr.vue?vue&type=script&lang=js&"
export * from "./modelAttr.vue?vue&type=script&lang=js&"
import style0 from "./modelAttr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports